import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import {
  ApiConfigData,
  GetMemberData,
  handleRedirectWithLoading,
  ModalOrSso,
  NavConfigureData,
  AppLogo,
  trackEvent,
  ClientPlatformCode,
  UserIdAndStatusData,
  UtilityReducer,
  DefaultCardName,
  SectionMasterData,
} from "../../Utility/Utility";

import getTranslation from "../../TranslationUtility/TranslationUtility";
import CustomBackHeader from "../../Utility/CustomBackHeader/CustomBackHeader";
import { useSelector } from "react-redux";
import PointBalance from "../PointBalance/pointBalance";
// import { onValidateLoginTokenReset } from "../../Store/Slices/validateLoginTokenSlice";
// import { onLandingHome } from "../../Store/Slices/homePageLandingSlice";
// import { useDispatch } from "react-redux";

const Header = ({ path, isMobileView, setShowModal, setIsLoading }) => {
  // const dispatch = useDispatch();
  const translation = getTranslation();
  const memberData = GetMemberData();
  const logo = AppLogo();
  const location = useLocation();
  const userName = memberData?.memberProfile;
  const isModal = ModalOrSso();
  const { clientCode, platformCode } = ClientPlatformCode();
  const { userId, userStatus } = UserIdAndStatusData();
  const defaultCardName = DefaultCardName();

  const card = UtilityReducer();
  const creditCards = card?.creditCards;
  const reduxTotalPointBalance = useSelector((state) => state.utilityReducer.totalPointBalance);
  const initials = (
    (userName?.firstName?.[0] || "N") + (userName?.lastName?.[0] || "A")
  ).toUpperCase();
  const apiConfigData = ApiConfigData();
  const { navConfigureData } = NavConfigureData(translation?.homePageHeader);
  const navigate = useNavigate();
  // Show site tour on mount (demo)
  const [showTour, setShowTour] = useState(false);

  const navItems = navConfigureData?.map((item) => {
    return {
      loginRequired: item?.isLogin,
      cta: item?.cta,
      navigationMenuName: item?.text,
      icon: (
        <img
          src={`${process.env.REACT_APP_CLIENT_IMAGE_URL}${item?.webImage}`}
          alt={item?.text}
          onError={(e) => {
            e.target.style.display = "none";
          }}
        />
      ),
    };
  });
  const integrationId = apiConfigData?.find(
    (data) => data?.paramsKey === "integrationId"
  )?.paramsValue;
  const loginUrl = `${process.env.REACT_APP_INTEGRATION_LOGIN_URL}Login/${integrationId}`;
  const isLoggedIn = Boolean(sessionStorage.getItem("login"));
  const { sectionMasterData } = SectionMasterData(isLoggedIn);
  const headerSectionData = sectionMasterData?.find(x => x?.sectionType === translation?.homePageHeader);

  const headerClickGAEventTracker = (tab) => {
    trackEvent("navigation_interaction", {
      cta_text: tab?.navigationMenuName,
      destination_url: tab?.cta,
      page_type: tab?.cta?.split("/")?.[1] || "home_page",
      client_code: clientCode,
      platform_code: platformCode,
      user_id: userId,
      user_status: userStatus,
      card_name: defaultCardName
    });
  }

  const handleLogin = (e, data) => {
    e.preventDefault();
    headerClickGAEventTracker(data);
    if (!data?.loginRequired && !data?.cta) return;
    if (!data?.loginRequired) {
      if (!/^https?:\/\//.test(data?.cta)) {
        navigate(data?.cta);
      } else {
        setIsLoading(true);
        window.open(data?.cta, "_self");
        setTimeout(() => setIsLoading(false), 10000);
      }
      // Fully handled above — without this it fell through to the final else below and
      // navigated a second time, leaving two identical history entries (back then landed on the
      // same page again).
      return;
    }
    if (data?.loginRequired && !isLoggedIn && isModal) {
      navigate("/");
      setShowModal(true);
    } else if (data?.loginRequired && !isLoggedIn && !isModal) {
      handleRedirectWithLoading(
        setIsLoading,
        data.cta,
        isLoggedIn,
        setShowModal,
        isModal,
        navigate,
        loginUrl
      );
    } else {
      if (!/^https?:\/\//.test(data?.cta)) {
        navigate(data?.cta);
      } else {
        if (data.cta) {
          handleRedirectWithLoading(
            setIsLoading,
            data.cta,
            isLoggedIn,
            setShowModal,
            isModal,
            loginUrl
          );
        }
      }
    }
  };
  const defaultHeader = (
    <>{!isMobileView ? <header id={`SEC_${headerSectionData?.id}`} className={isMobileView ? "" : "bg-white p-3 flex justify-between items-center shadow mb-1 "}>
      <div className="flex items-center space-x-4">
        {isMobileView && (
          <Link to="/side-navbar">
            <button
              className="text-xl menu-head"
              aria-label="Open navigation menu"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={2}
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            </button>
          </Link>
        )}
        {// !isLoggedIn &&
          (headerSectionData?.webImage ? (
            <Link to="/">
              <img
                src={`${process.env.REACT_APP_CLIENT_IMAGE_URL}${headerSectionData?.webImage}`}
                alt="Logo"
                className={`h-8 w-auto ${!isMobileView ? "ml-6" : ""}`}
              />
            </Link>
          ) : (
            ""
          ))}
      </div>
      {/* {!isMobileView && ( */}
      <nav className="flex items-center space-x-6">
        {navItems?.map((item, index) => (
          <Link
            key={index}
            data-url={item?.cta}
            onClick={(e) => handleLogin(e, item)}
            className={`nav-item ${path === item?.cta ? "active" : ""
              } flex items-center space-x-2`}
          >
            <span className="h-5 w-5">{item?.icon}</span>
            <span>{item.navigationMenuName}</span>
          </Link>
        ))}
      </nav>
      {/* )} */}
      {/* {isLoggedIn && (
        <h1 className="font-semibold line-hi">
          {translation?.rewardsAndDeals}
        </h1>
      )} */}
      <div>
        {isLoggedIn ? (
          <div
            // className="pro-nm rounded-full p-4 flex items-center justify-center w-8 h-8"
            className="pr-4"
            aria-label="User profile"
            onClick={() => {
              const totalPointBalance = creditCards.reduce(
                (sum, card) => sum + (card.pointBalance || 0),
                0
              );
              trackEvent("my_profile_click", {
                page_url: window.location.href,
                points: totalPointBalance,
                cta_text: Number(totalPointBalance) ? "Balance Points" : "My account",
                page_type: window.location.pathname === "/my-account" ? "my_account_page" : "home_page",
                client_code: clientCode,
                platform_code: platformCode,
                user_id: userId,
                user_status: userStatus,
                card_name: defaultCardName,
              });
            }}
          >
            {/* <Link>{initials}</Link> */}
            {isLoggedIn && headerSectionData?.headerSectionType === "MY_ACCOUNT" ? <PointBalance id={`tour_sec_${headerSectionData?.id}`} showTour={showTour} isMyAccount={false} /> : null}
            {isLoggedIn && headerSectionData?.headerSectionType === "PROFILE_ICON" && <div
              className="profile-icon rounded-full p-4 flex items-center justify-center w-8 h-8"
              aria-label="User profile"
              onClick={() => navigate("/my-account")}
            >
              <Link className="card-points text-gradient">{initials}</Link>
            </div>}
          </div>
        ) : integrationId ? (
          <button
            disabled={isLoggedIn && !integrationId}
            onClick={() => {
              handleRedirectWithLoading(
                setIsLoading,
                loginUrl,
                isLoggedIn,
                setShowModal,
                isModal,
                navigate,
                loginUrl
              );
            }}
            className={`login-ft px-4 py-2 disabled:cursor-not-allowed ${!isMobileView ? "mr-8" : ""
              }`}
            aria-label="Login"
          >
            {translation?.login}
          </button>
        ) : (
          ""
        )}
      </div>
    </header> : <></>}</>
  );

  const leftArrowHeader = (
    <>
      {/* {(path === "/contact-us" ||
        path === "/privacy-policy" ||
        path === "/terms-conditions") && isMobileView && <CustomBackHeader
          title={location?.state?.commonComponent
            ? location?.state?.Head
            : ""}
        />} */}
      {path === "/order-history" && <CustomBackHeader title={translation?.myOffersBenefits} />}
      {path === "/voucher-history" && <CustomBackHeader title={translation?.voucherHistory} />}
      {/* <header className="bg-white p-4 border-b-2 border-grey flex items-center">
        <div className="flex items-center space-x-4">
        <Link onClick={() => navigate(-1)}>
          <button className="text-xl menu-head" aria-label="Go back">
            {path === "/order-history" || path === "/voucher-history" ? (
              <i className="fa fa-angle-left"></i>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="2"
                stroke="currentColor"
                className="w-8 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M10 19l-7-7 7-7"
                />
                <line
                  x1="3"
                  y1="12"
                  x2="21"
                  y2="12"
                  stroke="currentColor"
                  strokeWidth="2"
                />
              </svg>
            )}
          </button>
        </Link>
      </div>

        {(path === "/contact-us" ||
          path === "/privacy-policy" ||
          path === "/terms-conditions") &&
          isMobileView ? (
          <h1 className="font-semibold line-hi banner-carousel">
            {location?.state?.commonComponent
              ? location?.state?.Head
              : null}
          </h1>
        ) : path === "/order-history" ? (
          <h1 className="font-semibold line-hi banner-carousel">
            {translation?.myOffersBenefits}
          </h1>
        ) : path === "/voucher-history" ? (
          <h1 className="font-semibold line-hi banner-carousel">
            {translation?.voucherHistory}
          </h1>
        ) : (
          ""
        )}
      </header> */}
    </>
  );

  if (path === "/contact-us" && !isMobileView) {
    return defaultHeader;
  }
  if (path === "/deal" && !isMobileView) {
    return defaultHeader;
  } else if (path === "/deal") {
    return null;
  }

  return path === "/" ||
    path === "/Offers" ||
    (!isMobileView && path === "/contact-us") ||
    (!isMobileView && path === "/privacy-policy") ||
    (!isMobileView && path === "/terms-conditions")
    ? defaultHeader
    : leftArrowHeader;
};

export default Header;
